import { useState } from "react";
import { useEAs, useEaHistory } from "../hooks/useDashboardData";
import { ProfitTodayChart, FloatingPnLChart, EquityHistoryChart } from "../components/HistoryCharts";

export function Charts() {
  const { data: easData, isLoading } = useEAs();
  const [selectedId, setSelectedId] = useState<string>("");

  const eas = easData?.eas ?? [];
  const effectiveId = selectedId || (eas.length > 0 ? String(eas[0].id) : "");

  const { data: historyData, isLoading: historyLoading } = useEaHistory(effectiveId);
  const history = historyData?.history ?? [];

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-sm font-semibold text-slate-300">Select an EA to inspect its charts</h2>
        <select
          value={effectiveId}
          onChange={(e) => setSelectedId(e.target.value)}
          className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-sm text-slate-100 outline-none ring-emerald-500/50 focus:ring-2"
        >
          {eas.map((ea) => (
            <option key={ea.id} value={ea.id}>
              {ea.account_name ? `${ea.account_name} (${ea.account_number})` : ea.account_number}
            </option>
          ))}
        </select>
      </div>

      {isLoading || historyLoading ? (
        <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-8 text-center text-slate-500">
          Loading chart data...
        </div>
      ) : eas.length === 0 ? (
        <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-8 text-center text-slate-500">
          No EAs have reported in yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
          <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
            <h3 className="mb-3 text-sm font-semibold text-slate-300">Profit Today</h3>
            <ProfitTodayChart history={history} />
          </div>
          <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
            <h3 className="mb-3 text-sm font-semibold text-slate-300">Floating PnL</h3>
            <FloatingPnLChart history={history} />
          </div>
          <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-4">
            <h3 className="mb-3 text-sm font-semibold text-slate-300">Equity History</h3>
            <EquityHistoryChart history={history} />
          </div>
        </div>
      )}
    </div>
  );
}
